import React, { useEffect, useState, useContext } from 'react';
import ApplicationContext from '../components/ApplicationContext';
import { setLocalStorage } from '../components/Utils';

const FAQ = ({ setData }) => {
    const data = useContext(ApplicationContext);

    const [faqData, setFaqData] = useState();

    useEffect(() => {
        window.scrollTo(0, 0);
        (async() => {
            if (data.BASE_URL) {
                const url = data.BASE_URL + "index.php/misc/get_faq";
                // console.log('DEBUG:', url);
                let formData = {
                    method: "GET",
                };
                let res = await fetch(url, formData);
                let resText = await res.text();
                // console.log('DEBUG:', resText);
                setFaqData(resText);
            }
        })();        
    }, [data.BASE_URL]);

	return (
        <>
            <div className="all-links-container">
                <h3 className="all-links">
                    <button className="link-button" onClick={(e) => {
						e.preventDefault();
                        setLocalStorage('currentPage', 'home');
                        data.currentPage = 'home';
						setData((prev) => ({ ...prev, currentPage: 'home' }))
				    }}>Back to Main</button>
                </h3>
            </div>

            <div dangerouslySetInnerHTML={{ __html: faqData }} />
        </>
	);
};

export default FAQ;
